import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import type { ProductFeature } from '@partful/shared-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { productFeatureNames } from 'src/constants/features';
import { useCurrentTabName } from 'src/hooks/useCurrentTabName';
import { useProductFeatures } from 'src/hooks/useProductFeatures';
import { useProduct } from 'src/providers/Product';
import { tabLink } from 'src/utils/urls';

export function EmptyTab() {
  const { t } = useTranslation(['partsCatalogue, productLibrary']);
  const { productId } = useProduct();

  const currentTabName = useCurrentTabName();
  const availableTabs = useProductFeatures();
  const otherTabName = availableTabs.find((tabName) => tabName !== currentTabName);

  return (
    <PaddedBox data-testid={`empty-tab-${currentTabName}`}>
      <CenteredP>
        <BigIcon icon={faCircleInfo} />
      </CenteredP>
      <MarginP>
        {t('partsCatalogue:noInformationAvailableFor', {
          context: productFeatureNames[currentTabName as ProductFeature],
        })}
      </MarginP>
      {otherTabName ? (
        /* istanbul ignore next */
        <MarginP>
          {t('partsCatalogue:backTo', { name: '' })}{' '}
          <UnderlinedLink to={tabLink(productId, otherTabName)}>
            {t(`productLibrary:features.${productFeatureNames[otherTabName]}`)}
          </UnderlinedLink>
          .
        </MarginP>
      ) : null}
    </PaddedBox>
  );
}

const MarginP = styled('p')`
  padding-bottom: 1rem;
`;

const CenteredP = styled(MarginP)`
  text-align: center;
`;

const PaddedBox = styled('div')`
  padding: 4rem 1rem;
  color: ${({ theme }) => theme.palette.sidebarBackground.contrastText};
`;

const UnderlinedLink = styled(Link)`
  text-decoration: underline;
`;

const BigIcon = styled(FontAwesomeIcon)`
  font-size: 2.5rem;
`;
